/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const DELETE_PASSWORD_POLICY = 'Delete Password Policy';
export const DELETE_PASSWORD_POLICY_CONTENT = 'Do you want to delete the password policy ';
export const DELETE = 'Delete';
export const CANCEL_BTN_TEXT = 'Cancel';
export const DELETE_PASSWORD_POLICY_SUCCESS = 'Password policy {0} deleted successfully';
export const DELETE_PASSWORD_POLICY_ERROR = 'Error while deleting password policy';
